import React, {createContext, useCallback, useContext, useState} from 'react';

interface DatasetColumnsContextType {
  columns: string[];
  setColumns: (columns: string[]) => void;
  getColumns: () => string[];
}

const DatasetColumnsContext = createContext<DatasetColumnsContextType | null>(
  null
);

export const useDatasetColumnsContext = () => {
  const context = useContext(DatasetColumnsContext);
  if (!context) {
    throw new Error(
      'useDatasetColumnsContext must be used within a DatasetColumnsProvider'
    );
  }
  return context;
};

export const DatasetColumnsProvider: React.FC<{
  children: React.ReactNode;
}> = ({children}) => {
  const [columns, setColumns] = useState<string[]>([]);

  const getColumns = useCallback(() => {
    return columns;
  }, [columns]);

  return (
    <DatasetColumnsContext.Provider value={{columns, setColumns, getColumns}}>
      {children}
    </DatasetColumnsContext.Provider>
  );
};
